import FullScreenLoader from "../../BON Frontend/Booking-Form/Common/FullScreenLoader";
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import '../../../App.css';
import SideBar from '../commun/SideBar';
import Hearder from '../commun/Hearder';

import { PropertyBusinessSourceList, PropertyGuaranteeCodes, PropertyMarketSegmentApi, PropertyMealplan, PropertyPMSDetails, PropertyRateCode, SaveAgentdetail } from '../../Services/Service';

const NewAgent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState([]);
  const [guaranteeCodes, setGuaranteeCodes] = useState([]);
  const [pmsRows, setPmsRows] = useState([{ id: 1, MealPlanID: "", RateCodeID: "" }]);
  const [emailRows, setEmailRows] = useState([{ id: 1, Email: "", IsActive: false }]);

  const [mealplan, setMealplan] = useState([]);
  const [ratecode, setRatecode] = useState([]);
  const [marketSegment, setMarketSegment] = useState([]);
  const [businessSources, setBusinessSources] = useState([]);

  const agentData = location.state?.agentData || null;

  const [formData, setFormData] = useState({
    AgentID: 0,
    Email: '',
    Password: '',
    FirstName: '',
    MidlleName: '',
    LastName: '',
    DOB: '',
    Gender: '',
    Address: '',
    City: '',
    State: '',
    Country: '',
    PinCode: '',
    TA_Name: '',
    Website: '',
    MobileNo: '',
    TelNo: '',
    TelEx: '',
    Gst: '',
    Pan: '',
    PMSCode: '',
    MarketSegment: '',
    BusinessSource: '',
    BillingInstructions: '',
    GuaranteeCode: '',
    AgentCode: '',
    ProfileID: "",
    ProfileType: "",
    OperaProfileID: "",
    IsPushMealPlan: 0,
    MaxRoomBook: 0,
  });

  useEffect(() => {
    if (agentData) {
      setFormData((prev) => ({ ...prev, ...agentData, Email: agentData.Username || "", GuaranteeCode: agentData.guaranteeCodes || "", ProfileID: agentData.OperaProfileID || "", }));
    }
  }, [agentData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  // NEW: MealPlanJson ab pmsRows se banega (sirf wahi rows jinme dono select ho chuke hain)
  const MealPlanJson = pmsRows
    .filter((row) => row.MealPlanID && row.RateCodeID)
    .map((row) => ({
      MealPlanID: Number(row.MealPlanID),
      RateCodeID: Number(row.RateCodeID)
    }));

  // Email notification table ko API body ke required format me convert karega
  const EmailNotificationJson = emailRows
    .filter((row) => row.Email.trim() !== "")
    .map((row) => ({
      Email: row.Email.trim(),
      IsActive: Boolean(row.IsActive),
    }));

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    const isEdit = !!formData.AgentID;

    const payload = {
      ...formData,
      Hotel: localStorage.getItem("selectedPropertyID") || "0",
      AgentID: formData.AgentID || 0,
      Status: 1,
      CreatedBy: null,
      ModifyBY: null,
      CreatedDateTime: new Date().toISOString(),
      ModifyDateTime: new Date().toISOString(),
      AgentCode: formData.AgentCode || "AGENT-" + Date.now(),
      AgencyLogo: "",
      AccountManager: "2",
      IsPushMealPlan: formData.IsPushMealPlan,
      MaxRoomBook: formData.MaxRoomBook,
      ProfileID: formData.ProfileID || formData.OperaProfileID || null,
      OperaProfileID: formData.ProfileID || formData.OperaProfileID || null,
      guaranteeCodes: formData.GuaranteeCode,
      MealPlanJson: MealPlanJson,
      EmailNotificationJson: EmailNotificationJson,
    };

    try {
      const result = await SaveAgentdetail(payload);
      navigate("/Property/AgentList", {
        state: { success: isEdit ? "Agent Updated successfully" : "Agent Registered successfully" }
      });
    } catch (error) {
      console.error("Agent not saved:", error);
      alert("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };


  const handlePMSDetailSearch = async (e) => {
    e.preventDefault();
    if (!searchTerm.trim()) return;

    try {

      setLoading(true);

      const res = await PropertyPMSDetails(searchTerm, "agent"); // passing Name + ProfileType

      const profiles = res?.Result?.profileSummaries?.profileInfo || [];
      setResults(profiles);
    } catch (error) {
      console.error("Search error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const modal = document.querySelector(".bs-example-modal-lg");

    const handleModalClose = () => {
      setSearchTerm("");  // input reset
      setResults([]);    // results reset
    };

    if (modal) {
      modal.addEventListener("hidden.bs.modal", handleModalClose);
    }

    return () => {
      if (modal) {
        modal.removeEventListener("hidden.bs.modal", handleModalClose);
      }
    };
  }, []);


  const handleSelectAgent = (agent) => {
    const profile = agent.profile;
    const profileIdObj = agent.profileIdList?.[0] || {};

    setFormData((prev) => ({
      ...prev,
      TA_Name: profile.formerName?.name || "",
      Address: profile.addressInfo?.address?.addressLine?.filter(Boolean).join(", ") || "",
      City: profile.addressInfo?.address?.cityName || "",
      State: profile.addressInfo?.address?.state || "",
      Country: profile.addressInfo?.address?.country?.value || "",
      PinCode: profile.addressInfo?.address?.postalCode || "",
      ProfileID: profileIdObj.id || "",
      ProfileType: profileIdObj.type || ""
    }));

    // Modal close karne ke liye bootstrap modal method
    const modal = document.querySelector(".bs-example-modal-lg");
    if (modal) {
      const bootstrapModal = window.bootstrap.Modal.getInstance(modal);
      bootstrapModal.hide();
    }
  };


  useEffect(() => {
    const FetchMArketSegment = async () => {
      setLoading(true);
      try {
        const result = await PropertyMarketSegmentApi();
        // setMarketSegment(result || []);
        if (Array.isArray(result)) setMarketSegment(result);
      }
      catch (error) {
        console.log("error fetching market segment", error);
      } finally {
        setLoading(false);
      }
    }
    FetchMArketSegment();
  }, []);


  useEffect(() => {
    const fetchBusinessSource = async () => {
      setLoading(true);
      try {
        const data = await PropertyBusinessSourceList();
        if (Array.isArray(data)) setBusinessSources(data);
      } catch (error) {
        console.log("Error fetching business sources:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBusinessSource();
  }, []);

  useEffect(() => {
    const fetchGuaranteeCodes = async () => {
      setLoading(true);
      try {
        const data = await PropertyGuaranteeCodes();
        if (Array.isArray(data)) setGuaranteeCodes(data);
      } catch (error) {
        console.log("Error fetching gurantee Codes:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchGuaranteeCodes();
  }, []);

  const handleAddPmsRow = () => {
    setPmsRows((prev) => [
      ...prev,
      { id: Date.now(), MealPlanID: "", RateCodeID: "" }
    ]);
  };

  const handleDeletePmsRow = (id) => {
    setPmsRows((prev) => prev.filter((row) => row.id !== id));
  };

  const handlePmsRowChange = (id, field, value) => {
    setPmsRows((prev) =>
      prev.map((row) =>
        row.id === id ? { ...row, [field]: value } : row
      )
    );
  };


  const handleAddEmailRow = () => {
    setEmailRows((prev) => [
      ...prev,
      { id: Date.now(), Email: "", IsActive: false }
    ]);
  };

  const handleEmailRowChange = (id, email) => {
    setEmailRows((prev) =>
      prev.map((row) =>
        row.id === id ? { ...row, Email: email } : row
      )
    );
  };

  const handleEmailStatusChange = (id) => {
    setEmailRows((prev) =>
      prev.map((row) =>
        row.id === id
          ? { ...row, IsActive: !row.IsActive }
          : row
      )
    );
  };

  const handleDeleteEmailRow = (id) => {
    setEmailRows((prev) => {
      const updatedRows = prev.filter((row) => row.id !== id);

      return updatedRows.length > 0
        ? updatedRows
        : [{ id: Date.now(), Email: "", IsActive: false }];
    });
  };

  useEffect(() => {
    const FetchMealplan = async () => {
      setLoading(true);
      try {
        const result = await PropertyMealplan();
        // if (Array.isArray(result)) setMealplan(result);
        if (Array.isArray(result)) {
          setMealplan(result);
        }
      }
      catch (error) {
        console.log("error get meal plan", error);
      } finally {
        setLoading(false);
      }
    }
    FetchMealplan();
  }, []);

  useEffect(() => {
    const fetchRatecode = async () => {
      setLoading(true);
      try {
        const result = await PropertyRateCode();
        if (Array.isArray(result)) setRatecode(result);
      } catch (error) {
        console.log("error get rate code", error);
      } finally {
        setLoading(false);
      }
    };
    fetchRatecode();
  }, []);

  return (
    <>
      {loading && (
        <FullScreenLoader />
      )}

      <div className="wrapper">
        <SideBar />
        <div className="main-panel">
          <Hearder />
          <div className="container">
            <div className="page-inner">

              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title">{formData.AgentID ? "Edit Agent" : "Agent Registration"}</div>
                    </div>
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          {/* Name of Agency/Operator */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Name of The Agency/Operator</label>
                              <div className='d-flex'>
                                <input type="text" name="TA_Name" className="form-control"
                                  value={formData.TA_Name || ""}
                                  onChange={handleChange}
                                  placeholder="Name of The Agency/Operator"
                                />
                                <button type="button" class="btn btn-primary btn-sm mx-2 " data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg"><i className='fas fa-search'></i></button>
                              </div>
                            </div>
                          </div>

                          {/* Address */}
                          <div className="col-md-8">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Address</label>
                              <textarea
                                type="text"
                                name="Address"
                                rows="2"
                                className="form-control"
                                value={formData.Address || ""}
                                onChange={handleChange}
                                placeholder="Address"
                              />
                            </div>
                          </div>

                          {/* State */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">State</label>
                              <input
                                type="text"
                                name="State"
                                className="form-control"
                                value={formData.State || ""}
                                onChange={handleChange}
                                placeholder="State"
                              />
                            </div>
                          </div>

                          {/* Country */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Country</label>
                              <input
                                type="text"
                                name="Country"
                                className="form-control"
                                value={formData.Country || ""}
                                onChange={handleChange}
                                placeholder="Country"
                              />
                            </div>
                          </div>

                          {/* City */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">City</label>
                              <input
                                type="text"
                                name="City"
                                className="form-control"
                                value={formData.City || ""}
                                onChange={handleChange}
                                placeholder="City"

                              />
                            </div>
                          </div>

                          {/* Pin Code */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Pin Code</label>
                              <input
                                type="number"
                                name="PinCode"
                                className="form-control"
                                value={formData.PinCode || ""}
                                onChange={handleChange}
                                placeholder="Pin Code"
                              />
                            </div>
                          </div>

                          {/* Website */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Agency/Operator Website</label>
                              <input
                                type="text"
                                name="Website"
                                className="form-control"
                                value={formData.Website || ""}
                                onChange={handleChange}
                                placeholder="Website"

                              />
                            </div>
                          </div>

                          {/* First Name */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Contact Person First Name</label>
                              <input
                                type="text"
                                name="FirstName"
                                className="form-control"
                                value={formData.FirstName || ""}
                                onChange={handleChange}
                                placeholder="First Name"

                              />
                            </div>
                          </div>

                          {/* Middle Name */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Middle Name</label>
                              <input
                                type="text"
                                name="MidlleName"
                                className="form-control"
                                value={formData.MidlleName || ""}
                                onChange={handleChange}
                                placeholder="Middle Name"
                              />
                            </div>
                          </div>

                          {/* Last Name */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Last Name</label>
                              <input
                                type="text"
                                name="LastName"
                                className="form-control"
                                value={formData.LastName || ""}
                                onChange={handleChange}
                                placeholder="Last Name"

                              />
                            </div>
                          </div>

                          {/* Mobile Number */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Mobile Number</label>
                              <input
                                type="number"
                                name="MobileNo"
                                className="form-control"
                                value={formData.MobileNo || ""}
                                onChange={handleChange}
                                placeholder="Mobile Number"

                              />
                            </div>
                          </div>

                          {/* Telephone Number */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Telephone Number</label>
                              <input
                                type="text"
                                name="TelNo"
                                className="form-control"
                                value={formData.TelNo || ""}
                                onChange={handleChange}
                                placeholder="Telephone Number"
                              />
                            </div>
                          </div>

                          {/* Telephone Extension */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Telephone Extension</label>
                              <input
                                type="text"
                                name="TelEx"
                                className="form-control"
                                value={formData.TelEx || ""}
                                onChange={handleChange}
                                placeholder="Telephone Extension"
                              />
                            </div>
                          </div>

                          {/* Date of Birth */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Date of Birth</label>
                              <input type="date" name="DOB" className="form-control" value={formData.DOB || ""} onChange={handleChange} />
                            </div>
                          </div>

                          {/* Email */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Email</label>
                              <input type="email" name="Email" className="form-control" value={formData.Email || ""} onChange={handleChange} placeholder="Email" />
                            </div>
                          </div>

                          {/* Password */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Password</label>
                              <input type="password" name="Password" className="form-control" value={formData.Password || ""} onChange={handleChange} placeholder="Password" />
                            </div>
                          </div>

                          {/* GST Number */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">GST Number</label>
                              <input type="text" name="Gst" className="form-control" value={formData.Gst || ""} onChange={handleChange} placeholder="GST Number" />
                            </div>
                          </div>

                          {/* PAN Number */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">PAN Number</label>
                              <input type="text" name="Pan" className="form-control" value={formData.Pan || ""} onChange={handleChange} placeholder="PAN Number" />
                            </div>
                          </div>

                          {/* PMS Code */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">PMS Code</label>
                              <input type="text" name="PMSCode" className="form-control" value={formData.PMSCode || ""} onChange={handleChange} placeholder="PMS Code" />
                            </div>
                          </div>

                          {/* Gender Dropdown */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Gender</label>
                              <select className="form-control form-select" name="Gender" value={formData.Gender || ""} onChange={handleChange}>
                                <option value="">Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                              </select>
                            </div>
                          </div>

                          {/* Market Segment Dropdown */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Market Segment</label>
                              <select
                                className="form-control form-select"
                                name="MarketSegment"
                                value={formData.MarketSegment || ""}
                                onChange={handleChange}
                              >
                                <option value="">Select Market Segment</option>

                                {marketSegment.map((item) => (
                                  <option key={item.ID} value={item.Code}>
                                    {item.MarketSeg}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          {/* Business Source Dropdown */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Business Source</label>
                              <select
                                className="form-control form-select"
                                name="BusinessSource"
                                value={formData.BusinessSource || ""}
                                onChange={handleChange}
                              >
                                <option value="">Select Business Source</option>

                                {businessSources.map((item) => (
                                  <option key={item.ID} value={item.Code}>
                                    {item.BusinessSource}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          {/* Billing Instructions Dropdown */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Billing Instructions</label>
                              <select className="form-control form-select" name="BillingInstructions" value={formData.BillingInstructions || ""} onChange={handleChange} >
                                <option value="">Select Billing Instructions</option>
                                <option value="Pay at hotel">Pay at hotel</option>
                                <option value="Prepaid">Prepaid</option>
                                <option value="Send Invoice">Send Invoice</option>
                              </select>
                            </div>
                          </div>

                          {/* Guaraneet Code Dropdown */}
                          <div className="col-md-4">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Guaraneet Code</label>
                              <select
                                className="form-control form-select"
                                name="GuaranteeCode"
                                value={formData.GuaranteeCode || ""}
                                onChange={handleChange}
                              >
                                <option value="">Select Guarantee Code</option>

                                {guaranteeCodes.map((item) => (
                                  <option key={item.ID} value={item.Code}>
                                    {item.guaranteeCodes}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div className='col-md-3'>
                            <div className="input-block mb-3">
                              <label className="col-form-label">Maximum Room Can book</label>
                              <input type='number' className='form-control' name='MaxRoomBook' value={formData.MaxRoomBook} onChange={handleChange} />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Meal Plan send</label>
                              <div className='d-flex gap-2'>
                                <input type='radio' name="IsPushMealPlan"
                                  value={1}
                                  checked={formData.IsPushMealPlan === 1}
                                  onChange={(e) =>
                                    setFormData((prev) => ({
                                      ...prev,
                                      IsPushMealPlan: Number(e.target.value)
                                    }))
                                  } />
                                <label className='form-label mt-1 me-4'>Yes</label>

                                <input type='radio' name="IsPushMealPlan"
                                  value={0}
                                  checked={formData.IsPushMealPlan === 0}
                                  onChange={(e) =>
                                    setFormData((prev) => ({
                                      ...prev,
                                      IsPushMealPlan: Number(e.target.value)
                                    }))
                                  } />
                                <label className='form-label mt-1'>No</label>
                              </div>
                            </div>
                          </div>

                          {/* ===== NEW DYNAMIC PMS CONFIGURATION TABLE ===== */}
                          <div className='col-md-6 mb-3'>

                            <div className='d-flex justify-content-between align-items-center mb-2'>
                              <label className='form-label fs-5 fw-bold'>PMS Configration</label>
                              <button
                                type="button"
                                className='btn btn-sm text-primary px-1'
                                onClick={handleAddPmsRow}
                              >
                                <i className='fas fa-plus me-2'></i>Add Row
                              </button>
                            </div>

                            <table className="table table-hover table-bordered table-small">
                              <thead>
                                <tr className='bg-light'>
                                  <th>Meal Plan</th>
                                  <th>Rate Code</th>
                                  {pmsRows.length > 0 && <th style={{ width: "90px" }}>Action</th>}
                                </tr>
                              </thead>

                              <tbody>
                                {pmsRows.map((row, index) => (
                                  <tr key={row.id}>
                                    {/* Meal Plan dropdown */}
                                    <td>
                                      <select
                                        className="form-select form-select-sm"
                                        value={row.MealPlanID}
                                        onChange={(e) =>
                                          handlePmsRowChange(row.id, "MealPlanID", e.target.value)
                                        }
                                      >
                                        <option value="">Select Meal Plan</option>

                                        {mealplan.map((meal) => (
                                          <option
                                            key={meal.MealPlanID}
                                            value={meal.MealPlanID}
                                          >
                                            {meal.Code}
                                          </option>
                                        ))}
                                      </select>
                                    </td>

                                    {/* Rate Code dropdown */}
                                    <td>
                                      <select
                                        className="form-select form-select-sm"
                                        value={row.RateCodeID}
                                        onChange={(e) =>
                                          handlePmsRowChange(row.id, "RateCodeID", e.target.value)
                                        }
                                      >
                                        <option value="">
                                          Select Rate Code
                                        </option>

                                        {ratecode.map((rate) => (
                                          <option
                                            key={rate.RateCodeID}
                                            value={rate.RateCodeID}
                                          >
                                            {rate.Name}
                                          </option>
                                        ))}
                                      </select>
                                    </td>

                                    {/* Delete button - pehli (default) row me nahi, baad wali rows me dikhega */}
                                    {pmsRows.length > 0 && (
                                      <td className="text-center">
                                        <button
                                          type="button"
                                          className="btn btn-sm text-danger"
                                          onClick={() => handleDeletePmsRow(row.id)}
                                        >
                                          <i className="fas fa-trash"></i>
                                        </button>
                                      </td>
                                    )}
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          {/* ===== END NEW DYNAMIC PMS CONFIGURATION TABLE ===== */}

                          <div className='col-md-6 mb-2'>

                            <div className='d-flex justify-content-between align-items-center mb-2'>
                              <label className='form-label fs-5 fw-bold'>Email Notification</label>
                              <button
                                type="button"
                                className='btn btn-sm text-primary px-1'
                                onClick={handleAddEmailRow}
                              >
                                <i className='fas fa-plus me-2'></i>Add Row
                              </button>
                            </div>

                            <table className="table table-hover table-bordered table-small">
                              <thead>
                                <tr className='bg-light'>
                                  <th>Email</th>
                                  <th className='text-center' style={{ width: '52px' }}>Status</th>
                                  <th style={{ width: "90px" }}>Action</th>
                                </tr>
                              </thead>

                              <tbody>
                                {emailRows.map((row) => (
                                  <tr key={row.id}>
                                    <td>
                                      <input
                                        type='email'
                                        className='form-control form-control-sm'
                                        value={row.Email}
                                        onChange={(e) => handleEmailRowChange(row.id, e.target.value)}
                                        placeholder='Enter email address'
                                      />
                                    </td>
                                    <td className='text-center align-middle' style={{ width: '52px', padding: '4px' }}>
                                      <button
                                        type='button'
                                        role='switch'
                                        aria-checked={row.IsActive}
                                        onClick={() => handleEmailStatusChange(row.id)}
                                        className='border-0 position-relative text-white fw-semibold'
                                        style={{
                                          width: '42px',
                                          height: '22px',
                                          borderRadius: '11px',
                                          backgroundColor: row.IsActive ? '#28a745' : '#6c757d',
                                          cursor: 'pointer',
                                          transition: 'background-color 0.2s ease'
                                        }}
                                        aria-label={`Mark ${row.Email || 'email'} as ${row.IsActive ? 'inactive' : 'active'}`}
                                      >
                                        <span
                                          aria-hidden='true'
                                          className='position-absolute bg-white rounded-circle'
                                          style={{
                                            width: '14px',
                                            height: '14px',
                                            top: '4px',
                                            left: row.IsActive ? '24px' : '4px',
                                            boxShadow: '0 1px 4px rgba(0, 0, 0, 0.25)',
                                            transition: 'left 0.2s ease'
                                          }}
                                        />
                                      </button>
                                    </td>
                                    <td className='text-center'>
                                      <button
                                        type='button'
                                        className='btn btn-sm text-danger'
                                        onClick={() => handleDeleteEmailRow(row.id)}
                                        aria-label='Delete email row'
                                      >
                                        <i className='fas fa-trash'></i>
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>

                        </div>

                        <div className="card-action text-end">
                          <button type="submit" className="btn btn-primary">
                            {formData.AgentID ? "Update Agent" : "Register Now"}
                          </button>
                        </div>
                      </form>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <>
              {/*  Large modal example */}
              <div
                className="modal fade bs-example-modal-lg"
                tabIndex={-1}
                role="dialog"
                aria-labelledby="myLargeModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="myLargeModalLabel">
                        Search Agent
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body">
                      <div className='row'>
                        <div className='col-ms-12'>
                          <form className='row' onSubmit={handlePMSDetailSearch}>
                            <div className='col-md-4'>
                              <div className='mb-3'>
                                <input type='text' className='form-control' placeholder="Search here..." value={searchTerm}
                                  onChange={(e) => setSearchTerm(e.target.value)} />
                              </div>
                            </div>
                            <div className='col-md-1'>
                              <div className='mb-3'>
                                <button type='submit' className='btn btn-primary '>Search</button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>

                      <div className='row'>
                        <div className='col-md-12'>

                          <div className='table-responsive'>
                            <table className='table '>
                              <thead>
                                <tr>
                                  <th>Sr #</th>
                                  <th>Name</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {results.length > 0 ? (
                                  results.map((item, index) => (
                                    <tr key={item.profileIdList?.[0]?.id || index}>
                                      <td>{index + 1}</td>
                                      <td>{item.profile?.formerName?.fullName}</td>
                                      <td>
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-primary"
                                          onClick={() => handleSelectAgent(item)}
                                        >
                                          Select
                                        </button>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="3" className="text-center">
                                      {loading
                                        ? "Searching..."
                                        : "No results. Please search other agent."}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  {/* /.modal-content */}
                </div>
                {/* /.modal-dialog */}
              </div>
              {/* /.modal */}
            </>

          </div>

        </div>
      </div >
    </>
  );
};

export default NewAgent;
